<template>
  <div>
    <div class="title" @click="goBack">
      <van-icon name="arrow-left" />
      <h2>我的兑换</h2>
    </div>
    <div class="content">
      <div class="application-title">
        我的申请 剩余{{ myPoints }}积分
      </div>
      <table class="application-table">
        <thead>
          <tr>
            <th>序号</th>
            <th>申请物品</th>
            <th>申请时间</th>
            <th>消耗积分</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in applications" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.goodsName }}</td>
            <td>{{ formatDate(item.createTime) }}</td>
            <td>{{ item.consumePoints }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getExchangeRecord } from '@/api/index'
export default {
  name: "tryOut",
  data() {
    return {
      applications: [
      ],
      myPoints: ''
    };
  },
  mounted() {
    this.getExchangeRecord();
    let user = JSON.parse(localStorage.getItem('user'));
    this.myPoints = user.points
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    handleAction(item) {
      // 撤销申请的逻辑
      console.log("撤销申请:", item);
      // 这里可以添加 API 调用来撤销申请
    },
    //获取兑换记录
    async getExchangeRecord() {
      let data = {
        page: 1,
        size: 999
      }
      const res = await getExchangeRecord(data);
      this.applications = res.content;
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${month}-${day}`;
    },
  },
};
</script>

<style>
.title {
  padding: 20px 20px 10px;
  font-size: 20px;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
}

.content {
  padding: 20px;
  padding-bottom: 60px;
}

.application-table {
  width: 100%;
  border-collapse: collapse;
}

.application-table th,
.application-table td {
  border: 1px solid #e0e0e0;
  padding: 10px;
  text-align: left;
}

.application-table th {
  background-color: #f9f9f9;
}

.application-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
